export default __webpack_public_path__ + "static/media/ro.493e60b2.svg";